import { render, staticRenderFns } from "./FilterRemove.vue?vue&type=template&id=57f0a6ba"
import script from "./FilterRemove.vue?vue&type=script&lang=js"
export * from "./FilterRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports